import styled from 'styled-components';

export const UeLicensesWrapper = styled.div`
    .outer-flex {
        display: flex;
        ${(p) => p.theme.breakpoints.up('lg')} {
            .standard-card {
                .License-links-caption {
                    border-top: 1px solid ${(p) => p.theme.palette.common.black};
                    width: 100%;
                    left -${(p) => p.theme.spacing(6)}px;
                    position: relative;
                    padding: ${(p) => p.theme.spacing(6)}px ${(p) => p.theme.spacing(6)}px 0;
                    .bottom-links {
                        margin: 0;
                        padding-left: 0;
                    }
                }
            }
        }
        ${(p) => p.theme.breakpoints.only('md')} {
            flex-direction: column;
            width: 83.333%;
            margin: 0 auto;
            .standard-card {
                & > div {
                    width: 40%;
                    margin: 0 auto;
                }
                .License-title-description,
                .License-links-caption {
                    width: 60%;
                    text-align: center;
                }
                .License-links-caption {
                    .bottom-links {
                        padding-left: 0;
                        justify-content: center;
                    }
                }
            }
            .right {
                background-color: ${(p) => p.theme.palette.background.default};
            }
        }
        ${(p) => p.theme.breakpoints.up('md')} {
            .standard {
                display: flex;
                .standard-card {
                    display: flex;
                    flex-direction: column;
                }
            }
        }
        .right {
            display: flex;
            flex-direction: column;
            .top {
                display: flex;
                height: 100%;
                > div {
                    width: 50%;
                }
            }
            .bottom {
                background-color: ${(p) => p.theme.palette.background.default};
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                ${(p) => p.theme.breakpoints.up('md')} {
                    border-top: 1px solid ${(p) => p.theme.palette.neutral.silver};
                    height: 100%;
                }
            }
        }
    }

    ${(p) => p.theme.breakpoints.down('sm')} {
        .outer-flex {
            flex-direction: column;
            .standard-card {
                width: 100%;
            }
            .right {
                .top {
                    flex-direction: column;
                    > div {
                        width: 100%;
                    }
                }
            }
        }
    }
`;
